import { MutableRefObject } from 'react'
import { GridColDef } from '@microservices/wiskey-react-table-component'

import { ObjectXDynamicCell } from '@components/TimeLineGrid/components/ObjectXDynamicCell'
import { getDynamicColumnFieldKey } from '@components/TimeLineGrid/helpers/getDynamicColumnFieldKey'
import { isGroupTitleRow } from '@components/TimeLineGrid/helpers/isGroupTitleRow'

import { TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME } from '@constants'
import { COLUMN_TYPE, ObjectDataRecord, TimelineCellContext, TimeLineDTOType } from '@types'

import { useHandlers } from '../hooks'

import { getColumnHeaderNameForColumnObject } from './getColumnHeaderNameForColumnObject'
import { getPathString } from '@helpers'
import { get } from 'lodash'
import { getFilteredColumnsObjectDataByObjectXData } from '@components/TimeLineGrid/helpers/getFilteredColumnsObjectDataByObjectXData'

type Params = {
  config: TimeLineDTOType
  handlers: ReturnType<typeof useHandlers>
  cellContextRef: MutableRefObject<TimelineCellContext>
  columnsObjectData: ObjectDataRecord[]
}

export const getColumnsByObject = (params: Params): GridColDef[] => {
  const { config, columnsObjectData, cellContextRef, handlers } = params

  if (!columnsObjectData?.length) {
    return []
  }

  const yColumns = config.objectY.columns || []
  const xColumns = config.objectX?.columns || []

  const processedColumnsObjectData = handlers.state.isFilterColumnsObjectByObjectXFilter
    ? getFilteredColumnsObjectDataByObjectXData({
        config,
        objectXData: handlers.data.objectXDataRef.current,
        columnsObjectData,
      })
    : columnsObjectData

  return processedColumnsObjectData.map(item => {
    return {
      columnType: COLUMN_TYPE.DATE_INTERVAL,
      field: getDynamicColumnFieldKey(item, config.objectX.fieldFromColumnsObjectToLink),
      flex: 1,
      headerName: getColumnHeaderNameForColumnObject({ config, item }),
      minWidth: config.objectX.cell?.minWidth,
      sortable: false,
      resizable: false,
      disableReorder: true,
      disableColumnMenu: true,
      cellClassName: params =>
        isGroupTitleRow(params.id as string) ? '' : TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME,
      colSpan: (_, row) => {
        if (isGroupTitleRow(row.id)) {
          return (
            yColumns.filter(item => !item.pinnedColumn).length +
            columnsObjectData.length +
            xColumns.filter(item => !item.pinnedColumn).length
          )
        }

        return 1
      },
      renderCell: params => {
        return (
          <ObjectXDynamicCell
            cellContextRef={cellContextRef}
            config={config}
            handlers={handlers}
            params={params}
          />
        )
      },
    }
  })
}
